module.exports = {
  url: 'https://fadfadah.net/ksu-gpa',
}